/**
 * Analytics Event Constants
 * 
 * Centralized event names for PostHog tracking.
 * 
 * Event Naming Convention:
 * - Use snake_case for event names
 * - Group related events with common prefixes (e.g., "auth_", "home_", "expense_")
 * - Frontend events don't need "api_" prefix (that's for backend events)
 */

export const AnalyticsEvents = {
  // Authentication & Onboarding Events
  USER_SIGNED_UP: 'user_signed_up',
  USER_LOGGED_IN: 'user_logged_in',
  USER_LOGGED_OUT: 'user_logged_out',
  ONBOARDING_STARTED: 'onboarding_started',
  ONBOARDING_STEP_COMPLETED: 'onboarding_step_completed',
  ONBOARDING_COMPLETED: 'onboarding_completed',
  
  // Home Management Events
  HOME_CREATED: 'home_created',
  HOME_VIEWED: 'home_viewed',
  HOME_UPDATED: 'home_updated',
  HOME_MEMBER_INVITED: 'home_member_invited',
  HOME_MEMBER_JOINED: 'home_member_joined',
  HOME_SWITCHED: 'home_switched',
  
  // Finance Events
  EXPENSE_CREATED: 'expense_created',
  EXPENSE_VIEWED: 'expense_viewed',
  EXPENSE_UPDATED: 'expense_updated',
  EXPENSE_DELETED: 'expense_deleted',
  EXPENSE_LIST_VIEWED: 'expense_list_viewed',
  
  // Scheduling Events
  SCHEDULING_CREATED: 'scheduling_created',
  SCHEDULING_VIEWED: 'scheduling_viewed',
  SCHEDULING_UPDATED: 'scheduling_updated',
  SCHEDULING_DELETED: 'scheduling_deleted',
  SCHEDULING_LIST_VIEWED: 'scheduling_list_viewed',
  
  // Document Events
  DOCUMENT_UPLOADED: 'document_uploaded',
  DOCUMENT_VIEWED: 'document_viewed',
  DOCUMENT_DOWNLOADED: 'document_downloaded',
  DOCUMENT_DELETED: 'document_deleted',
  DOCUMENT_LIST_VIEWED: 'document_list_viewed',
  
  // Workflow Events
  WORKFLOW_CREATED: 'workflow_created',
  WORKFLOW_STEP_COMPLETED: 'workflow_step_completed',
  WORKFLOW_COMPLETED: 'workflow_completed',
  WORKFLOW_VIEWED: 'workflow_viewed',
  
  // Engagement Events
  FEATURE_DISCOVERED: 'feature_discovered',
  SETTINGS_VIEWED: 'settings_viewed',
  SETTINGS_UPDATED: 'settings_updated',
  PROFILE_VIEWED: 'profile_viewed',
  PROFILE_UPDATED: 'profile_updated',
  HELP_ACCESSED: 'help_accessed',
  
  // Navigation Events
  PAGE_VIEWED: 'page_viewed',
  NAVIGATION_CLICKED: 'navigation_clicked',
} as const;

export type AnalyticsEventName = typeof AnalyticsEvents[keyof typeof AnalyticsEvents];
